import { NgModule } from '@angular/core';
import { GlobalFiltersComponentModule } from './global-filters-component.module';
import { StoreModule } from '@ngrx/store';
import { filterReducer } from './store';
import { globalFiltersStateKey } from './models/global-filters-state.interface';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [],
  imports: [
    GlobalFiltersComponentModule,
    TranslateModule,
    StoreModule.forFeature(globalFiltersStateKey, filterReducer),
  ],
  exports: [GlobalFiltersComponentModule],
})
export class GlobalFiltersModule {}
